module.exports = __webpack_public_path__ + "img/03.02a6c09d.jpg";